module.exports = __webpack_public_path__ + "media/images/equipments-img-04-99191283ef96117b6365e25a35d60f53.png";